exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#reorder_elements_modal li {\n  cursor: move;\n}\n#reorder_elements_modal .badge {\n  font-weight: 500;\n  margin-top: 0.3rem;\n  font-size: 1.3rem;\n}\n#reorder_elements_modal .btn-success {\n  margin: 0 auto;\n}", ""]);

// exports
